module.exports = __webpack_public_path__ + "media/images/iles turks-0d2be98ff20d6dc50f47134671d3ca38.svg";